import React, { Suspense } from "react";
import "./App.css";
import NavbarComponent from "./components/navbar/NavbarComponent";

const ProfileComponent = React.lazy(() =>
  import("./components/profile/ProfileComponent")
);
const AboutComponent = React.lazy(() =>
  import("./components/about/AboutComponent")
);
const ExperienceComponent = React.lazy(() =>
  import("./components/experience/ExperienceComponent")
);
const ProjectsComponent = React.lazy(() =>
  import("./components/projects/ProjectsComponent")
);
const ContactComponent = React.lazy(() =>
  import("./components/contact/ContactComponent")
);
const FooterComponent = React.lazy(() =>
  import("./components/footer/FooterComponent")
);

function App() {
  return (
      <Suspense fallback={<h1 className="loading">Loading...</h1>}>
    
          <Suspense fallback={<h1 className="loading">Loading...</h1>}>
            <NavbarComponent />
          </Suspense>
          <Suspense fallback={<h1 className="loading">Loading...</h1>}>
            <ProfileComponent />
          </Suspense>
          <Suspense fallback={<h1 className="loading">Loading...</h1>}>
            <AboutComponent />
          </Suspense>
          <Suspense fallback={<h1 className="loading">Loading...</h1>}>
            <ExperienceComponent />
          </Suspense>
          <Suspense fallback={<h1 className="loading">Loading...</h1>}>
            <ProjectsComponent />
          </Suspense>
          <Suspense fallback={<h1 className="loading">Loading...</h1>}>
            <ContactComponent />
          </Suspense>

          <Suspense fallback={<h1 className="loading">Loading...</h1>}>
            <FooterComponent />
          </Suspense>
        

      </Suspense>
  );
}

export default App;
